<template lang="html">
  <span>
    <b-field class="is-marginless">
      <template slot="label">
        Character
        <b-tooltip
          position="is-right"
          type="is-dark"
          multilined
          size="is-small"
          label="Character linked to the Project"
        >
          <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-input
        v-model="localCharacter"
        maxlength="50"
        placeholder="e.g. Hatsune Miku"
        @input="updateCharacter"
      ></b-input>
    </b-field>

    <b-field class="is-marginless">
      <template slot="label">
        Version
        <b-tooltip
          position="is-right"
          type="is-dark"
          multilined
          size="is-small"
          label="Version of the Character or Universe in the Project"
        >
          <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-input
        v-model="localVersion"
        maxlength="50"
        placeholder="e.g. Christmas"
        @input="updateVersion"
      ></b-input>
    </b-field>
    <b-field class="is-marginless">
      <template slot="label">
        Universe
        <b-tooltip
          position="is-right"
          type="is-dark"
          multilined
          size="is-small"
          label="Universe from which the Project comes from"
        >
          <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-input
        v-model="localUniverse"
        maxlength="50"
        placeholder="e.g. Vocaloid"
        @input="updateUniverse"
      ></b-input>
    </b-field>
  </span>
</template>

<script>
export default {
  props: ['character', 'version', 'universe'],
  data () {
    return {
      localCharacter: null,
      localVersion: null,
      localUniverse: null
    }
  },
  created () {
    this.localCharacter = this.character
    this.localVersion = this.version
    this.localUniverse = this.universe
  },
  methods: {
    updateCharacter (value) {
      this.$emit('updateCharacter', value)
    },
    updateVersion (value) {
      this.$emit('updateVersion', value)
    },
    updateUniverse (value) {
      this.$emit('updateUniverse', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
